import React from "react";
import { Link } from "react-router-dom";
import "./Abouthome.css";

export default function Abouthome() {
  return (
    <section className="about">
      <div className="about__wrapper">
        {/* ── Text content ───────────────────────────── */}
        <div className="about__content">
          <div className="about__header">
            <span className="about__subtitle">Our Philosophy</span>
            <h2 className="about__title">
              Finding The Landscaper That Works Best For You
            </h2>
          </div>

          <div className="about__text-content">
            <p className="about__text">
              Landscaping is more than routine upkeep — it’s about building and
              caring for outdoor spaces that last. At Primed Landscaping, we
              specialize in quality hardscapes, dependable maintenance, and the
              details that keep a property looking its best.
            </p>
            <p className="about__text">
              
                What started as a commitment to doing things the right way has
              grown into a company built on craftsmanship, consistency, and
              attention to detail. From clean-ups and irrigation to precision
              maintenance and well-built hardscape features, we treat every
              property as if it were our own. Proudly serving Maple Valley and
              the surrounding areas, our story is rooted in hard work — and it’s
              still being written.
            </p>
          </div>

          {/* ── CTA buttons ──────────────────────────── */}
          <div className="about__cta">
            <Link to="/about/who-we-are" className="about__button">
              <span>More About Us</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M5 12H19M19 12L12 5M19 12L12 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>

            <Link
              to="/contact"
              className="about__button about__button--secondary"
            >
              <span>Contact Us</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 6L12 13L2 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* ── Image content ─────────────────────────── */}
        <div className="about__image-wrapper">
          <div className="about__image-container">
            <img
              src="/IMG_4620.jpeg"
              alt="Primed Landscaping team at work"
              className="about__image"
              loading="lazy"
            />
          </div>
          <div className="about__image-overlay" />
        </div>
      </div>
    </section>
  );
}
